import { render, staticRenderFns } from "./monitorStyle.vue?vue&type=template&id=5f07962c&scoped=true"
import script from "./monitorStyle.vue?vue&type=script&lang=js"
export * from "./monitorStyle.vue?vue&type=script&lang=js"
import style0 from "./monitorStyle.vue?vue&type=style&index=0&id=5f07962c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f07962c",
  null
  
)

export default component.exports